var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcContentSettings(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "26px",
    viewBox: "0 0 26 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic-content-settings") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "--Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic-mainnav-settings",
    transform: "translate(1.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#53575C",
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,9 C6.27614237,9 6.5,9.22385763 6.5,9.5 L6.5,18.5 C6.5,18.7761424 6.27614237,19 6,19 C5.72385763,19 5.5,18.7761424 5.5,18.5 L5.5,9.5 C5.5,9.22385763 5.72385763,9 6,9 Z",
    id: "Rectangle",
    fill: "#53575C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,5 C12.2761424,5 12.5,5.22385763 12.5,5.5 L12.5,14.5 C12.5,14.7761424 12.2761424,15 12,15 C11.7238576,15 11.5,14.7761424 11.5,14.5 L11.5,5.5 C11.5,5.22385763 11.7238576,5 12,5 Z",
    id: "Rectangle",
    fill: "#53575C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18,13 C18.2761424,13 18.5,13.2238576 18.5,13.5 L18.5,18.5 C18.5,18.7761424 18.2761424,19 18,19 C17.7238576,19 17.5,18.7761424 17.5,18.5 L17.5,13.5 C17.5,13.2238576 17.7238576,13 18,13 Z",
    id: "Rectangle",
    fill: "#53575C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18,5 C18.2761424,5 18.5,5.22385763 18.5,5.5 L18.5,9.5 C18.5,9.77614237 18.2761424,10 18,10 C17.7238576,10 17.5,9.77614237 17.5,9.5 L17.5,5.5 C17.5,5.22385763 17.7238576,5 18,5 Z",
    id: "Rectangle",
    fill: "#53575C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7,5.5 L7.5,9 L5,9.5 L4.5,6 L7,5.5 Z",
    id: "Rectangle",
    stroke: "#53575C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13,14.5 L13.5,18 L11,18.5 L10.5,15 L13,14.5 Z",
    id: "Rectangle",
    stroke: "#53575C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19,9.5 L19.5,13 L17,13.5 L16.5,10 L19,9.5 Z",
    id: "Rectangle",
    stroke: "#53575C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcContentSettings);
export default __webpack_public_path__ + "static/media/ic-content-settings.4a3622b0012edc017fe7e01dbb647483.svg";
export { ForwardRef as ReactComponent };